import { normalize } from 'normalizr';
import { filter, keys, length, lt, map, mapObjIndexed, pipe, without, is, isNil } from 'ramda';
import { entryArraySchema } from '../../modules/contentRegistry/contentRegistry.schema';

export default function normalizeData({ items = [], includes = {} }) {
  const normalizedData = normalize([...items, ...(includes.Entry || []), ...(includes.Asset || [])], entryArraySchema);
  const hasAnyFields = pipe(
    keys,
    without('sys'),
    length,
    lt(0)
  );
  const filterNonEmptyEntities = mapObjIndexed(filter(hasAnyFields));

  return filterNonEmptyEntities(normalizedData.entities);
}

export const flattenFields = srcData => {
  if (!is(Object, srcData) || isNil(srcData)) {
    return srcData;
  }
  const { fields = {}, ...otherProps } = srcData;
  const flatObj = Array.isArray(srcData) ? srcData : { ...otherProps, ...fields };
  return map(flattenFields, flatObj);
};
